import { Player } from "@lottiefiles/react-lottie-player";
import { Button } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import FirebaseKey from "../../components/FirebaseKey/FirebaseKey";
import Loading from "../../components/Loading/Loading";
import { MeDto } from "../../core/models/dtos/me.dto";
import { ApiEvent } from "../../core/models/enums/apiEvent";
import { apiEventRequest } from "../../core/services/eventService/apiEvent/repository";
import FirebaseService from "../../core/services/firebaseService/firebase.service";
import { Helpers } from "../../core/utilities/helpers";
import { history } from "../../core/utilities/history";
import { IStore } from "../../core/utilities/reducers";
import { router } from "../../core/utilities/router";
import "./HomePage.scss";

interface IProps {
  me?: MeDto;
}

interface IState {
  isLottiePlayerLoading: boolean;
}

class HomePage extends Component<IProps> {
  state: IState = {
    isLottiePlayerLoading: true,
  };

  componentDidMount() {
    FirebaseService.logEvent(FirebaseService.user_count_homepage_view, {
      newcomer: this.isUserNewComer(),
    });
    apiEventRequest({
      ...Helpers.getApiEventCoreData(this.props.me),
      event: ApiEvent.HOMEPAGE_VIEW,
    }).catch();
  }

  private isUserNewComer(): boolean {
    return !this.props.me?.termsAcceptanceDate;
  }

  private handleStart(): void {
    FirebaseService.logEvent(FirebaseService.user_count_startgame_clicked);
    apiEventRequest({
      ...Helpers.getApiEventCoreData(this.props.me),
      event: ApiEvent.START_GAME,
    }).catch();
    history.push(router.QUESTION);
  }

  private getSrcLottie(): string {
    return (
      FirebaseService.getValue(FirebaseService.onboarding_lottie_url) ??
      "https://static.4play.com.tr/do-bos-yok/onb.json"
    );
  }

  render() {
    return (
      <div id="home-page" className="page">
        <div className="page-content">
          {this.state.isLottiePlayerLoading && (
            <Loading className="lottie-placeholder" fontSize={64} />
          )}
          <Player
            key="lottie-player-home"
            className="lottie-player"
            src={this.getSrcLottie()}
            autoplay
            loop
            speed={2}
            onEvent={(event) => {
              if (event === "play") {
                this.setState({ isLottiePlayerLoading: false });
              }
            }}
          />
          <div className="action-card">
            <FirebaseKey
              className="title"
              firebaseKey={
                this.isUserNewComer()
                  ? FirebaseService.home_newcomer_title
                  : FirebaseService.home_title
              }
            />
            {this.isUserNewComer() && (
              <FirebaseKey
                className="text"
                firebaseKey={FirebaseService.home_newcomer_desc}
              />
            )}
            <Button
              className="app-button action"
              onClick={() => this.handleStart()}
            >
              <FirebaseKey
                firebaseKey={
                  this.isUserNewComer()
                    ? FirebaseService.home_newcomer_button
                    : FirebaseService.home_button
                }
              />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({}, dispatch);
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
